<template>
  <v-autocomplete
    v-model="select"
    :items="persons"
    :filter="filter"
    item-value="personId"
    :search-input.sync="search"
    :error-messages="errorMessages"
    flat
    :rounded="rounded"
    :label="labelText"
    :disabled="disabled"
    :clearable="clearable"
  >
    <template v-slot:selection="{ item }">
      <v-list-item-content>
        <v-list-item-title>{{ item.firstName }} {{ item.lastName }}</v-list-item-title>
      </v-list-item-content>
    </template>

    <template v-slot:item="{ item }">
      <v-list-item-content>
        <v-list-item-title v-text="item.firstName + ' ' + item.lastName"></v-list-item-title>
        <v-list-item-subtitle v-text="getRoles(item)"></v-list-item-subtitle>
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script>
import utils from "@/utils";

/*
 * nodel input value format:
 *   person object
 */
export default {
  name: "PersonField",
  props: {
    value: {
      type: Object
    },
    rounded: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    errorMessages: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      select: null,
      search: null,
      persons: null
    };
  },

  methods: {
    filter(item, queryText) {
      const text = item.firstName.toLowerCase() + " " + item.lastName.toLowerCase();
      return text.indexOf(queryText.toLowerCase()) > -1;
    },

    setValue(value) {
      this.select = (value !== null) ? value.personId : null;
    },

    getRoles(person) {
      return utils.personRoles(person).map((item) => this.$t("roles." + item)).join(", ");
    }
  },

  watch: {
    select: function() {
      if (this.persons !== null)
        this.$emit("input", this.persons.find(x => x.personId === this.select) || null);
    },

    value:  function() {
      this.setValue(this.value);
    },

    "$store.state.auth.company": function() {
      this.$store.dispatch("data/fetchPersons").then(persons => {
        this.persons = persons.data;
      });
    },

    "$store.state.groupsets.groupset": function() {
      this.$store.dispatch("data/fetchPersons").then(persons => {
        this.persons = persons.data;
      });
    }
  },

  computed: {
    labelText() {
      return (this.label !== null) ? this.label : this.$t("component.person_field.title");
    }
  },

  mounted() {
    this.$store.dispatch("data/fetchPersons").then(persons => {
      this.persons = persons.data;

      this.setValue(this.value);
    });
  }
};
</script>

<style scoped>

</style>